import { Image, Text, View } from "@react-pdf/renderer";
import { DocumentDetailResponse } from "apis/data-contracts";
import { DATE_TIME_FORMAT } from "config/constant";
import dayjs from "dayjs";
import React from "react";

export interface SignInfo {
  name: string;
  date: string;
  signImageUrl?: string;
}

export interface DocumentDetailSignSectionProps {
  documentApproveStatus: DocumentDetailResponse["approveStatus"];
  createdUserInfo: SignInfo;
  approvedUserInfo?: SignInfo;
  showApproverSign?: boolean;
  compact?: boolean;
}

const DocumentDetailSignSection = ({
  documentApproveStatus,
  createdUserInfo,
  approvedUserInfo,
  showApproverSign,
  compact = false,
}: DocumentDetailSignSectionProps) => {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: compact ? "10mm" : "20mm",
      }}
    >
      <SignPanel title="작성" signInfo={createdUserInfo} compact={compact} />

      <View
        style={{
          borderRightWidth: 1,
          borderRightColor: "#C6C8CD",
          height: "100%",
        }}
      />

      <SignPanel
        title="승인"
        compact={compact}
        signInfo={
          showApproverSign || documentApproveStatus === "APPROVE"
            ? approvedUserInfo
            : undefined
        }
      />
    </View>
  );
};

export default DocumentDetailSignSection;

interface SignPanelProps {
  title: string;
  signInfo?: SignInfo;
  compact?: boolean;
}

const SignPanel = ({ title, signInfo, compact = false }: SignPanelProps) => {
  return (
    <View
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          gap: compact ? "2mm" : "3mm",
        }}
      >
        <Text
          style={{
            fontFamily: "Pretendard",
            fontSize: compact ? "9pt" : "10pt",
            fontWeight: 700,
          }}
        >
          {title}
        </Text>

        <View
          style={{
            display: "flex",
            flexDirection: "column",
            gap: compact ? "1.2mm" : "2mm",
          }}
        >
          <View>
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: compact ? "9pt" : "10pt",
              }}
            >
              {signInfo?.name || " "}
            </Text>
          </View>
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: compact ? "9pt" : "10pt",
            }}
          >
            {signInfo?.date
              ? dayjs(signInfo.date).format(DATE_TIME_FORMAT)
              : " "}
          </Text>
        </View>
      </View>

      <View>
        {signInfo?.signImageUrl ? (
          <View>
            <Image
              src={`${signInfo?.signImageUrl}?timestamp=${Date.now()}`}
              style={{
                maxWidth: compact ? "12mm" : "16mm",
                maxHeight: compact ? "12mm" : "16mm",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </View>
        ) : (
          <View
            style={{
              width: compact ? "12mm" : "16mm",
              height: compact ? "12mm" : "16mm",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {signInfo?.name ? (
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: compact ? "9pt" : "10pt",
                }}
              >
                {signInfo?.name}
              </Text>
            ) : (
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: compact ? "9pt" : "10pt",
                  color: "#6D757F",
                }}
              >
                (서명)
              </Text>
            )}
          </View>
        )}
      </View>
    </View>
    // <SignPanelWrapStyle>
    //   <SignMetaInfoStyle>
    //     <SignMetaInfoTitleStyle>{title}</SignMetaInfoTitleStyle>
    //     <SignMetaInfoDescriptionStyle>
    //       <div>{signInfo?.name || " "}</div>
    //       <div>
    //         {signInfo?.date
    //           ? dayjs(signInfo.date).format(DATE_TIME_FORMAT)
    //           : " "}
    //       </div>
    //     </SignMetaInfoDescriptionStyle>
    //   </SignMetaInfoStyle>

    //   <SignBoxStyle>
    //     {signInfo?.signImageUrl ? (
    //       <SignImageStyle
    //         src={signInfo?.signImageUrl}
    //         alt={`${signInfo?.name || ""} 서명`}
    //       />
    //     ) : (
    //       signInfo?.name || <SignPlaceholderStyle>(서명)</SignPlaceholderStyle>
    //     )}
    //   </SignBoxStyle>
    // </SignPanelWrapStyle>
  );
};
